import { render } from "./BaseMessageAlerts.vue?vue&type=template&id=25a461da&scoped=true"
import script from "./BaseMessageAlerts.vue?vue&type=script&lang=js"
export * from "./BaseMessageAlerts.vue?vue&type=script&lang=js"

import "./BaseMessageAlerts.vue?vue&type=style&index=0&id=25a461da&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25a461da"]])

export default __exports__